module.exports = __webpack_public_path__ + "img/ico-trash.19d44843.svg";